import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { GlobalMappingSettingsService } from '../../../api/services/global-mapping-settings.service';
import { DataPageOfGlobalSettings } from '../../../api/models/data-page-of-global-settings';
import { Practice } from '../../../api/models/practice';
import { KeyValue } from '../../../api/models/key-value';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { validateAllFormFields } from '../../../formUtils';
import { Customsort } from '../../directives/customsort';

@Component({
    selector: 'app-global-mapping-setting',
    templateUrl: './global-mapping-setting.component.html',
    styleUrl: './global-mapping-setting.component.css'
})
export class GlobalMappingSettingComponent implements OnInit {
    globalSettingsList: DataPageOfGlobalSettings;
    practiceId: string;
    cols: any[];
    rows: number;
    showRecords: boolean;
    displaypopup: boolean = false;
    actionType: string;

    ddlPractices: Array<Practice>
    ddlSettingType: Array<KeyValue>;
    ddlSettingName: Array<KeyValue>;
    frmGlobalSettings: FormGroup;
    selectedSettingType: string = "PatientDemographic";
    patientDemographicOptions = [{ key: 'True', value: 'True' }, { key: 'False', value: 'False' }];
    selectedSettingId: number;

    ddlSettingTypeSearch: Array<KeyValue>;

    settingTypeSearchControl = new FormControl('PatientDemographic');

    isQuickPatientDemographicsLink: boolean = true;
    constructor(private messageService: MessageService, private router: Router, private route: ActivatedRoute, private confirmation: ConfirmationService, private globalMappingSettingsService: GlobalMappingSettingsService, private fb: FormBuilder, private customsort: Customsort) {

    }
    ngOnInit(): void {
        this.practiceId = localStorage.getItem('PracticeId');
        this.cols = [

            { field: 'settingName', header: 'Setting Name', sort: true },
            { field: 'settingValue', header: 'Setting Value', sort: true },
            { field: 'settingType', header: 'Setting Type', sort: true }
        ]


        this.frmGlobalSettings = this.fb.group({
            practiceId: [null],
            securityToken: [null],
            settingID: 0,
            settingName: [null, Validators.required],
            settingType: [null, Validators.required],
            settingValue: [null, Validators.required],
        });

        this.getDllSettingTypeSerach();

        this.getglobalMappingSettings(1, "", "");



        this.frmGlobalSettings
            .get('settingType')
            ?.valueChanges.subscribe((value) => {
                this.selectedSettingType = value;
                this.getDllSettingNameAsPerType(this.selectedSettingType);
            });


        this.settingTypeSearchControl?.valueChanges.subscribe(value => {
            console.log('Search query:', value);
            this.selectedSettingType = value;


            if (this.selectedSettingType.toUpperCase() == "PATIENTDEMOGRAPHIC") {


                this.isQuickPatientDemographicsLink = true;
            }
            else {
                this.isQuickPatientDemographicsLink = false;
            }
            this.getglobalMappingSettings(1, "", "");  // Call the search method
        });
    }





    getglobalMappingSettings(pageNumber: number, sortcolumn: string, sortorder: string): void
    {
        if (sortcolumn == '' && sortorder == '') {
            sortcolumn = 'settingName'
            sortorder = 'Asc'
        }
        var serachtext = '';

        this.globalMappingSettingsService.globalMappingSettingsSearch({
            practiceId: this.practiceId,
            pageSize: 10,
            pageNumber: pageNumber,
            searchText: this.selectedSettingType,
            SortByColumn: sortcolumn,
            SortByDirection: sortorder,

        }).subscribe((resp) => {

            this.globalSettingsList = resp

            console.log(this.globalSettingsList);

            // this.rows = this.globalSettingsList.data.length;


            this.rows = this.globalSettingsList.pageSize

            if (this.globalSettingsList.totalRecords > 0) {
                this.showRecords = true
            } else {
                this.showRecords = false
            }
            debugger


            this.globalSettingsList.data.forEach(item => {
                item.settingType = item.settingType.replace(/([a-z])([A-Z])/g, '$1 $2');
            });

            this.globalSettingsList.data.forEach(item => {
                item.settingName = item.settingName.replace(/([a-z])([A-Z])/g, '$1 $2');
            });

            if (this.globalSettingsList.totalRecords > 0) {
                this.showRecords = true
            } else {
                this.showRecords = false
            }
        });

    }


    onAddMappingSetting() {
        this.displaypopup = true;
        this.actionType = "Create";

        this.fillDropdownLists();

    }

    fillDropdownLists() {
        this.getDlPractice();
        this.getDllSettingType();


    }

    getDlPractice() {
        this.ddlPractices = JSON.parse(localStorage.getItem('user_practices'));

        this.ddlPractices[0];
    }

    getDllSettingType() {
        this.globalMappingSettingsService.globalMappingSettingsGetDropdownListGlobalSettingType().subscribe((resp) => {
            this.ddlSettingType = resp;


            this.frmGlobalSettings.controls['settingType'].setValue(this.selectedSettingType);


            if (this.actionType.toLowerCase() == "Create".toLowerCase()) {

                this.getDllSettingNameAsPerType(this.selectedSettingType);
            }
            else if (this.actionType.toLowerCase() == "Update".toLowerCase()) {
                this.getDllSettingNameAsPerType(this.selectedSettingType);
            }
            else {
                console.log("List");
            }
        });

    }


    getDllSettingTypeSerach() {
        this.globalMappingSettingsService.globalMappingSettingsGetDropdownListGlobalSettingType().subscribe((resp) => {
            // this.ddlSettingTypeSearch = resp;           
            this.ddlSettingTypeSearch = resp.filter(x => x.value != "Security Token");


        });

    }

    getDllSettingName() {
        this.globalMappingSettingsService.globalMappingSettingsGetDropdownListUiPreferences().subscribe((resp) => {

            this.ddlSettingName = resp.sort((a: KeyValue, b: KeyValue) => {
                return a.key.localeCompare(b.key);
            });
        })
    }


    getDllSettingNameAsPerType(settingType: any) {


        this.globalMappingSettingsService.globalMappingSettingsGetDropdownListTypeSetting({ settingType: settingType }).subscribe((resp) => {

            this.ddlSettingName = resp.sort((a: KeyValue, b: KeyValue) => {
                return a.key.localeCompare(b.key);
            });

            this.ddlSettingName = this.ddlSettingName.filter(item => item.value !== 'Address2');
        })
    }

    onEditGlobalMappingSetting(item: number) {
        this.displaypopup = true;
        this.actionType = "Update";
        this.selectedSettingId = item;
        this.globalMappingSettingsService.globalMappingSettingsFetch({ settingId: item }).subscribe((resp) => {

            this.selectedSettingType = resp.settingType;
            this.frmGlobalSettings.patchValue(resp);
            this.fillDropdownLists();
            // this.getDllSettingNameAsPerType(this.selectedSettingType);



        })
    }

    save() {

        validateAllFormFields(this.frmGlobalSettings)
        // console.log('user Form', this.userForm);
        if (this.frmGlobalSettings.invalid) {
            return
        }
        this.frmGlobalSettings.controls['practiceId'].setValue(this.practiceId);

        console.log(this.frmGlobalSettings.value);

        if (this.actionType.toLowerCase() == 'Create'.toLowerCase()) {
            this.globalMappingSettingsService.globalMappingSettingsCreate({ body: this.frmGlobalSettings.value }).subscribe(res => {
                this.messageService.add({ key: 'alertToast', severity: 'success', detail: "Global Setting Added", summary: 'Confirmation', life: 6000 });
                this.displaypopup = false;
                this.getglobalMappingSettings(1, "", "");
            },
                err => {
                    console.log(err.error);
                    if (err.status == 403) {
                        this.messageService.add({ severity: 'error', key: 'alertToast', summary: `Error::${err.statusText}`, detail: "You have encountered an error.You do not have authorization to do this action.Contact [customer service] for assistance", life: 9000 });
                    }
                    else if (err.status == 500) {
                        this.messageService.add({ severity: 'error', key: 'alertToast', summary: `Error::${err.statusText}`, detail: "You have encountered an error.Please refresh the page the page or try again later.Contact [customer service] for assistance", life: 9000 });
                    }
                    else {
                        this.messageService.add({ severity: 'error', key: 'alertToast', summary: 'Error', detail: "This setting name  or  setting value is already exist in the system.Please choose another setting name or setting value.", life: 3000 });
                    }

                });
        }
        else {
            this.globalMappingSettingsService.globalMappingSettingsPut({ id: this.selectedSettingId, body: this.frmGlobalSettings.value }).subscribe(res => {
                this.messageService.add({ key: 'alertToast', severity: 'success', detail: "Global Setting Updated", summary: 'Confirmation', life: 6000 });
                this.displaypopup = false;
                this.getglobalMappingSettings(1, "", "");
            },
                err => {
                    console.log(err.error);
                    if (err.status == 403) {
                        this.messageService.add({ severity: 'error', key: 'alertToast', summary: `Error::${err.statusText}`, detail: "You have encountered an error.You do not have authorization to do this action.Contact [customer service] for assistance", life: 9000 });
                    }
                    else if (err.status == 500) {
                        this.messageService.add({ severity: 'error', key: 'alertToast', summary: `Error::${err.statusText}`, detail: "You have encountered an error.Please refresh the page the page or try again later.Contact [customer service] for assistance", life: 9000 });
                    }
                    else {
                        this.messageService.add({ severity: 'error', key: 'alertToast', summary: 'Error', detail: "This setting name  or setting value is already exist in the system.Please choose another setting name or setting value.", life: 3000 });
                    }

                });

        }


    }

    customSort(event: SortEvent, num: number) {
        this.globalSettingsList.data = this.customsort.generalcustomSort(
            event,
            this.globalSettingsList.data,
        )
    }


    onDelateSettingNameAsPerType(settingID: number) {
        this.confirmation.confirm({
            key: 'delete_confirmation',
            message: 'Are you sure you want to delete this menu item alias?',
            accept: () => {
                this.globalMappingSettingsService
                    .globalMappingSettingsDelete2({ id: settingID })
                    .subscribe((result) => {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'success',
                            detail: 'menu item alias delete successfully',
                            summary: 'Confirmation',
                            life: 7000,
                        })
                        this.resetForm();
                        this.getglobalMappingSettings(1, "", "");
                    });

            },
        })
    }


    QuickLinkMappingPatientDemographics() {

        this.router.navigate(['administration', 'patient-demographics']);
    }

    resetForm() {
        this.displaypopup = false;
        this.frmGlobalSettings.controls['settingValue'].reset();
        this.frmGlobalSettings.controls['settingName'].reset();
    }
}
